import { store } from '@atredux/store'
import { resetAlert, IAlertOptionsType, setAlert } from '@atredux/slices/atAlertSlice'
import { getAlertOptions } from '@atredux/selectors/atAlertSelector'

export async function setAlertListener (event: any) {
    console.log('ATBase: Received request to set alert modal.')

    const message = event.data

    if (message && message.data && message.data.message && typeof message.data.message === 'string') {
        const alertData = {
            ...message.data,
            target: event,
        }
        store.dispatch(setAlert(alertData))
        return Promise.resolve({})
    } else {
        return Promise.reject(`Invalid request parameters, the 'message' field is mandatory`)
    }
}

export async function resetAlertListener () {
    console.log('ATBase: Received request to clear interrupt modal.')

    store.dispatch(resetAlert())

    return Promise.resolve({})
}
